// An address on the job sheet and the customer record with its point (BL-018, maps package 6): ui-web's
// AddressCheck in the page's light or dark, on Google's map with the session's key (the stand-in with
// none). With the company's maps off (QA-756) the stand-in says so, and someone who may change company
// settings gets "Turn on in Settings", to the maps' switch on its Setup page. Inside a .flw part, as
// ui-web's drawing is.
//
// "Move the pin" goes beside Navigate here, through AddressCheck's actions, once its action
// (locations.placePin, maps package 3) is built; until then the point is read only.
import { AddressCheck, type AddressPointView } from '@flowology/ui-web';
import { useShownTheme } from '../blueprint/theme.ts';
import { useMaps } from './maps-key.ts';
import { MAPS_TURN_ON } from './maps-turn-on.ts';

export { MAPS_TURN_ON };

export function AddressOnMap(p: {
  address: string;
  point: AddressPointView | null | undefined;
  /** Off where the address is written just above it (the customer record's rows). */
  showAddress?: boolean;
  /** Off for a long list of addresses: the source line and Navigate, no map. */
  withMap?: boolean;
}) {
  const theme = useShownTheme();
  const maps = useMaps();
  return (
    <AddressCheck
      address={p.address}
      point={p.point ?? null}
      theme={theme}
      mapsKey={maps.key}
      mapsOff={maps.off}
      turnOn={maps.mayTurnOn ? MAPS_TURN_ON : null}
      {...(p.showAddress === undefined ? {} : { showAddress: p.showAddress })}
      {...(p.withMap === undefined ? {} : { withMap: p.withMap })}
    />
  );
}
